export const URL_BASE = "https://findmyfriends.online"
export const URL_BASE_API = "https://findmyfriends.online"
export const MAX_RETRIES = 5